<script>
  import { Stretch } from 'svelte-loading-spinners';
  import Button, { Icon, Label } from '@smui/button';
  import { currentChannel } from '$lib/store';
  import { playlist } from '$lib/playlist-store';
  import { audio, states } from '$lib/audio-store';
  import { onMount } from 'svelte';
  import noImage from '$assets/no-artwork-grey-100x100.png';
  import Rating from '$lib/client/shared/rating.svelte';

  import { page } from '$app/stores';

  let minutesRemaining;
  let secondsRemaining;
  let audioPlayer;

  onMount(() => {
    audio.init(audioPlayer, $currentChannel);
  });

$: interval = setInterval(() => {
    if ($playlist.currentTrack) {
        const timeRemaining = $playlist.currentTrack.ends_at - Date.now();
        let secondsLeft = timeRemaining / 1000;

        if (secondsLeft >= 0) {
            minutesRemaining = parseInt(secondsLeft / 60);
            secondsRemaining = parseInt(secondsLeft % 60);
        }
    }
}, 1000);

$: trackImage = $playlist.currentTrack?.images ? $playlist.currentTrack.images.thumbnail : noImage;
</script>

<div id="audio-player" class="b--solid-t-small b--primary lined-up">
    <div class="current-track">
        {#if $playlist.currentTrack}
            <a href="/artists/{$playlist.currentTrack.artist.slug}">
                <img
                    src={trackImage}
          alt={`${$playlist.currentTrack.title} - ${$playlist.currentTrack.artist.name}`}
          width="48"
          height="48"
        />
      </a>
    {/if}
  </div>
  <audio preload="none" bind:this={audioPlayer} />

  {#if $audio.state === states.PLAYING}
    <Button class="stop" on:click={audio.stop}>
      <Icon class="material-icons u-mr-small">stop_circle</Icon>

      <Label>
        {#if $playlist.currentTrack}
          <span class="artist-name">{$playlist.currentTrack.artist.name} -</span>
          <span class="track-title">{$playlist.currentTrack.title}</span>
        {/if}
        <span class="countdown">
          {#if minutesRemaining !== undefined && secondsRemaining !== undefined}
            {minutesRemaining}:{secondsRemaining < 10 ? `0${secondsRemaining}` : secondsRemaining}
          {/if}
        </span>
      </Label>
    </Button>

    {#if $playlist.currentTrack}
      <Rating track={$playlist.currentTrack} />
    {/if}
  {/if}

  {#if $audio.state === states.STOPPED}
    <Button class="play" on:click={audio.play}>
      <Icon class="material-icons u-mr-small">play_circle</Icon>

      <Label>
        {#if $playlist.currentTrack}
          <span class="artist-name">{$playlist.currentTrack.artist.name} -</span>
          <span class="track-title">{$playlist.currentTrack.title}</span>
        {:else}
          Listen Now
        {/if}
      </Label>
    </Button>
  {/if}

  {#if $audio.state === states.PAUSED}
    <Button class="paused" on:click={audio.play}>
      <Icon class="material-icons u-mr-small">pause_circle</Icon>

      <Label>Listen Now</Label>
    </Button>
  {/if}

  {#if $audio.state === states.BUFFERING}
    <div class="buffering u-pl-small u-pr">
      <Stretch duration="2s" size="36" color="#00CCFE" />
      <span class="t-uppercas1e mdc-typography--button">Buffering, please wait...</span>
    </div>
  {/if}

  {#if $audio.state === states.OFFLINE}
    <Button on:click={audio.play}>
      <Icon class="material-icons offline">media_bluetooth_off</Icon>
      <Label>OFF AIR. Please check back later.</Label>
    </Button>
  {/if}
</div>
